<template>
  <div class="flex justify-center">
    <div class="py-10 lg:w-8/12 md:w-10/12 w-full px-4 md:px-6 lg:px-0">
      <d-message v-if="error" type="error" class="w-full mb-3">
        {{ error }}
      </d-message>
      <d-message v-if="successMessage" type="success" class="w-full mb-3">
        {{ successMessage }}
      </d-message>

      <h1 class="font-bold">
        Register
      </h1>

      <form v-if="!registered" ref="form" class="mt-16" @submit.prevent="submitForm">
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="First Name*">
              <d-input v-model="form.firstName" name="firstName" required />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Last Name*">
              <d-input v-model="form.lastName" name="lastName" required />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex -mx-5">
          <div class="md:w-full md:px-5 mb-3">
            <d-field label="Email Address*">
              <d-input v-model="form.email" name="email" required type="email" />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Password*">
              <p class="text-sm mb-2">Passwords must be six characters long and contain at least one number and uppercase letter</p>
              <d-input v-model="form.password" name="password" required type="password" />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Password Confirmation*">
              <d-input v-model="form.passwordConfirmation" name="passwordConfirmation" required type="password" />
            </d-field>
          </div>
        </div>
        
        <div class="md:flex -mx-5">
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="ZIP Code*">
              <d-input v-model="form.zipCode" name="zipCode" required />
            </d-field>
          </div>
          <div class="md:w-6/12 md:px-5 mb-3">
            <d-field label="Mobile Phone #">
              <d-input v-model="form.phoneNumber" name="phoneNumber" />
            </d-field>
          </div>
        </div>
        
        <p class="mb-4">By creating an account, you consent to the terms of the <u><a href="/legal/user-agreement.pdf">user agreement</a></u></p>

        <div class="md:flex justify-end items-center mt-8 hidden">
          <d-btn type="submit" :loading="saving">
            Register
          </d-btn>
        </div>
        <div class="md:hidden pt-5">
          <d-btn type="submit" :loading="saving" block>
            Register
          </d-btn>
        </div>
      </form>
      <div v-else class="mt-8">
        <template v-if="requiresEmailConfirmation">
          <p>Please verify your email before logging in. Check your inbox and spam folder for your verification link.</p>
          <p v-if="noReplyEmail" class="mt-2">
            The verification email is sent from <strong>{{ noReplyEmail }}</strong>. Search your inbox and spam folder for that address if you cannot find it.
          </p>
          <div class="mt-4">
            <d-btn :loading="resending" @click="resendConfirmation">
              Resend Verification Email
            </d-btn>
            <a class="ml-4" href="/login">Go to Login</a>
          </div>
        </template>
        <div v-else class="mt-4">
          <d-btn href="/login">
            Go to Login
          </d-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    parent: true,

    props: {
      orgSettings: {
        type: Object,
        default: () => null,
      },
    },

    data() {
      return {
        saving: false,
        resending: false,
        registered: false,
        requiresEmailConfirmation: true,
        error: '',
        successMessage: '',
        form: {
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          passwordConfirmation: '',
          zipCode: '',
          phoneNumber: '',
        },
      };
    },

    computed: {
      noReplyEmail() {
        return this.orgSettings?.noReplyEmail || '';
      },
    },

    methods: {
      async submitForm() {
        this.saving = true;
        this.error = '';
        try {
          const response = await axios.post('/api/user/register', this.form);
          this.registered = true;
          this.requiresEmailConfirmation = response.data?.requiresEmailConfirmation !== false;
          this.successMessage = this.requiresEmailConfirmation
            ? 'Your account was created. Please check your email to verify your account.'
            : 'Your account was created. You can now log in.';
        } catch (error) {
          this.error = error.response.data[0];
        } finally {
          this.saving = false;
        }
      },
      async resendConfirmation() {
        this.resending = true;
        this.error = '';
        try {
          const response = await axios.post('/api/user/register/resend-confirmation', { email: this.form.email });
          this.successMessage = response.data.message;
        } catch {
          this.error = 'We were unable to resend your verification email. Please try again.';
        } finally {
          this.resending = false;
        }
      },
    },
  };
</script>